import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer, private toastrService: ToastrService, private router: Router, private usersService: UsersService) { }
  public fileName = 'No file chosen';
  public file: any;
  public image: any;
  public userId:any;
  @Output() selectedTab:EventEmitter<string> = new EventEmitter();

  ngOnInit(): void {
    this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
    this.usersService.getUserDetails(this.userId).subscribe(
      (res:any)=>{
        this.fileName = res.photo?.originalname;
        this.image = res.photo?.buffer;
      }
    )
  }

  onFileUpload(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      this.fileName = event.target.files[0].name;
      this.file = event.target.files[0];
      reader.onload = (event) => {
        this.image = event.target.result.toString().split(",")[1];
      };
    }
  }

  getImage(image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  onUpdate() {
    let formData = new FormData();
    formData.append('photo', this.file);
    if (this.file) {
      this.usersService.updateUserPhoto(this.userId, formData).subscribe(
        res => {
          this.toastrService.success('Photo updated!')
          sessionStorage.setItem('dashboardTab',JSON.stringify('dashboard'));
          this.selectedTab.emit('dashboard');
        }
      );
    }
  }
}
